import Quadtree from '@timohausmann/quadtree-ts';
import gn from "genart";
const pick = gn.math.randomElementFromArray;

export default class Brancher {
    constructor( options ){
        this.maxSegments = 20000;
        window.brancher = this;
        this.margin = 1;
        this.options = options;
        this.style = options.style;
        this.levels = [];
        this.allSegments = [];
        this.allPolygons = [];
        this.intersections = [];
        this.walls = [];
        this.strokeAccentColor = pick( this.options.style.palette.accent )
        //this.noiseField = new gn.field.FieldTool ( pieceWidth, pieceHeight, 0.001, 0.01 );

        this.myTree = new Quadtree({
            width: pieceWidth,
            height: pieceHeight,
            x: 0,           // optional, default:  0
            y: 0,           // optional, default:  0
            maxObjects: 10, // optional, default: 10
            maxLevels: 8    // optional, default:  4
        });

        this.createWalls();
        this.createLevels();
    }
    
    drawPolygons(appObject, isSVG){
        
        let paintMode = window.configOptions.paintMode;

        let alphas = [ "60", "B0", "FF" ]
        let pp = appObject || p5App;
        let ctx = pp.drawingContext;
        
        this.allPolygons.forEach( (polygon,i) => {
            let fillColor = polygon.fillColor;
            
            // For SVG export we only paint solid fills. Gradients and offset not supported
            if( isSVG ){
                pp.push();
                pp.noStroke();
                pp.fill( fillColor+gn.math.randomElementFromArray( alphas ) );
                pp.beginShape();
                polygon.vertices.forEach( point => {
                    pp.vertex( point.x, point.y );
                });
                pp.endShape(pp.CLOSE);
                pp.pop();
            }else{
                // If not SVG, paint normal
                if( gn.math.random() < paintMode.gradientChance ){
                    pp.push();
                    pp.noStroke();
                    
                    let gradient = ctx.createLinearGradient( polygon.vertices[0].x, polygon.vertices[0].y, polygon.vertices[1].x, polygon.vertices[1].y );
                    gradient.addColorStop(0, fillColor+gn.math.randomElementFromArray( alphas ));
                    gradient.addColorStop( gn.math.randomInRange(0.9,0.5), fillColor+"00");
                    
                    ctx.fillStyle = gradient;
                    ctx.beginPath();
                    ctx.moveTo(polygon.vertices[0].x, polygon.vertices[0].y );
                    polygon.vertices.forEach( (point, i) => {
                        if( i> 0)
                        ctx.lineTo( point.x, point.y );
                    });
                    ctx.closePath();
                    ctx.fill();
                    pp.pop();
                }
    
                if( gn.math.random() < paintMode.solidChance ){
                    pp.push();
                    pp.noStroke();
                    pp.fill( fillColor+gn.math.randomElementFromArray( alphas ) );
                    pp.beginShape();
                    polygon.vertices.forEach( point => {
                        pp.vertex( point.x, point.y );
                        //pp.circle( point.x, point.y, 10 );
                    });
                    pp.endShape(pp.CLOSE);
                    pp.pop();
                }
    
                if( gn.math.random() < paintMode.offsetChance ){
                    pp.push();
                    // Test with materials
                    pp.noFill();
                    let p1 = polygon.vertices[0];
                    let p2 = polygon.vertices[1];
                    let clr1 = fillColor+gn.math.randomElementFromArray( alphas );
                    let clr2 = fillColor+"00"
                    let materials = [
                        //new gn.materials.PlainColorFill( '#ff0000a0' ), 
                        //new gn.materials.PlainColorFill( '#EEEEEE' ), 
                        //new gn.materials.LinearGradientFillMaterial( ['#00ff0020', '#cc33ff'], p1, p2 ), 
                        //new gn.materials.SpaghettiMaterial( ["#000000", clr2] ), 
                        //new gn.materials.SprinkleMaterial( ['#000000', fillColor], 5, 10, 200 ), 
                        //new gn.materials.LinearGradientFillMaterial( [clr1, clr2], p1, p2 ), 
                        new gn.materials.OffsetMaterial( clr1, polygon.offsetRadius, polygon.offsetGap ), 
                    ];
                    let shape = new gn.shapes.Polygon( polygon.vertices, null, materials, fillColor );
                    pp.pop();
                }
            }            
        });
    }

    drawSegments(appObject){
        let pp = appObject || p5App;
        this.allSegments.forEach( segment => {
            segment.draw(pp);
        });
    }


    createWalls(){
        let margin = this.margin;
        let tl = {x:margin, y:margin};
        let tr = {x:pieceWidth-margin, y:margin};
        let br = {x:pieceWidth-margin, y:pieceHeight-margin};
        let bl = {x:margin, y:pieceHeight-margin};

        //console.log( "Walls: ", tl, tr, br, bl );
        let wall;
        wall = new Segment( this, null, 0, { p0: tl, p1: tr }, true, true );        
        this.walls.push( wall );        
        
        wall = new Segment( this, null, 0, { p0: tr, p1: br }, true, true );        
        this.walls.push( wall );
        
        wall = new Segment( this, null, 0, { p0: br, p1: bl }, true, true );        
        this.walls.push( wall );
        
        wall = new Segment( this, null, 0, { p0: bl, p1: tl }, true, true );        
        this.walls.push( wall );
    }



    createLevels(){
        let margin = this.margin;
        let drawingRectangle = [margin, pieceWidth-margin, margin, pieceHeight-margin ];
        let mySegmentSeeds = []
        for( let i=0; i<this.options.seedLines.length; i++){
            let seedLine = this.options.seedLines[i];
            let seedRectIntersections = gn.geom.liangBarskyLineRectIntersect( seedLine.p0.x, seedLine.p0.y, seedLine.p1.x, seedLine.p1.y, drawingRectangle, "segment" );
            if( seedRectIntersections ){
                let segment = new Segment( this, null, 0, seedRectIntersections, true, false );
                mySegmentSeeds.push( segment );
            }
        }
        mySegmentSeeds.forEach( segment => {
            segment.sprout();
        });
        
    }
}
class PolygonObject{
    constructor(style, vertices){

        let colorDistribute = window.configOptions.colorDistribute;
        this.offsetRadius = gn.math.randomInRange( 9, 6 );
        this.offsetGap = this.offsetRadius * gn.math.randomInRange(1.1,1.2);

        let fillColor;
        if( colorDistribute.type == "linearGradient" ){
            let distToFocal = gn.math.distance( vertices[0], {x:vertices[0].x, y:pieceHeight*colorDistribute.startY});
            let colors = style.palette.accent;
            let clrIndex = Math.floor( gn.math.map( distToFocal, 0, pieceHeight*colorDistribute.startY, 0, colors.length ) );
            fillColor = colors[clrIndex];
            if( fillColor == undefined ){
                fillColor = colors[clrIndex-1]
            }
            // Always randomize a bit so the gradient is not too evident
            if( gn.math.random() < 0.3 ){
                fillColor = pick( colors );
            }
        }else if( colorDistribute.type == "radialGradient" ){
            let focalPoint = {x:pieceWidth*colorDistribute.startX, y:pieceHeight*colorDistribute.startY}
            let distToFocal = gn.math.distance( vertices[0], focalPoint);
            let maxDist = gn.math.distance( focalPoint, {x:pieceWidth*colorDistribute.endX, y:pieceHeight*colorDistribute.endY} );
            let colors = style.palette.accent;
            let clrIndex = Math.floor( gn.math.map( distToFocal, 0, maxDist, 0, colors.length ) );
            fillColor = colors[clrIndex];
            if( fillColor == undefined ){
                fillColor = colors[clrIndex-1] 
            }
            // Always randomize a bit so the gradient is not too evident
            if( gn.math.random() < 0.3 ){
                fillColor = pick( colors );
            }
        }else if( colorDistribute.type == "random" ){
            fillColor = gn.math.randomElementFromArray(style.palette.accent)
        }
        this.fillColor = fillColor;
        this.vertices = vertices;
    }
}
class Segment{
    static _uidCounter = 0;
    // lineSegment is an object with p0, p1 properties of type point object
    constructor( system, parent, level, lineSegment, skipIntersect, skipDraw ){
        this.id = Segment._uidCounter++;
        system.allSegments.push( this );
        this.system = system;
        this.parent = parent;
        this.level = level;
        this.lineSegment = lineSegment;
        this.skipIntersect = skipIntersect;
        this.skipDraw = skipDraw;
        this.angle = gn.geom.getPointAngle( lineSegment.p1, lineSegment.p0 );
        this.strokeAccent = gn.math.random() < 0.10;
        

        this.qtIndex = function(node) {
            return Quadtree.Line.prototype.qtIndex.call({
                x1: this.lineSegment.p0.x,
                y1: this.lineSegment.p0.y,
                x2: this.lineSegment.p1.x,
                y2: this.lineSegment.p1.y,
            }, node);
        }

        if( !skipIntersect ){
            
            let intersections = [];
            let intersectedSegments = [];
            
            let candidates = this.system.myTree.retrieve(this);
            
            candidates.forEach( (segment, i) => {
                if( segment !== this && segment !== this.parent){
                    let intersection = gn.geom.intersection( this.lineSegment, segment.lineSegment );
                    if( intersection && 
                        intersection.x > 0  && intersection.x < pieceWidth  && 
                        intersection.y > 0  && intersection.y < pieceHeight )
                    {
                        intersections.push( intersection );
                        intersectedSegments.push( segment );
                    }
                }
            });
            let closestIntersectedSegment = null;
            if( intersections.length > 0 ){
                let closestIntersection = null;
                let closestDistance = Number.MAX_VALUE;
                intersections.forEach( (intersection, i) => {
                    let distance = gn.math.distance( intersection, this.lineSegment.p0 );
                    if( distance < closestDistance ){
                        closestDistance = distance;
                        closestIntersection = intersection;
                        closestIntersectedSegment = intersectedSegments[i];
                    }
                });
                
                this.lineSegment.p1 = closestIntersection;
            }
            this.closestIntersectedSegment = closestIntersectedSegment;
        }
        
        
        system.myTree.insert(this);
    }

    sprout(){        
        if( this.level < this.system.options.style.tree_numLevels ){
            let myBranches = [];

            let posConfig = this.system.options.style.branch_positions;
            let concentration;
            
            if( posConfig.type == 'random' ){
                let numBranches = posConfig.num instanceof Function ? posConfig.num(this.level) : posConfig.num;
                concentration = gn.math.arrayOfRandomNumbers( numBranches, posConfig.min, posConfig.max );
            }else if( posConfig.type == 'by_level' ){
                let numBranches = posConfig.values[this.level]
                concentration = gn.math.arrayOfRandomNumbers( numBranches, posConfig.min, posConfig.max );
            }else if( posConfig.type == 'computed' ){
                let numBranches = posConfig.num(this)
                concentration = gn.math.arrayOfRandomNumbers( numBranches, posConfig.min, posConfig.max );
            }else if( posConfig.type == 'fixed' ){
                concentration = posConfig.values;
            }else{
                throw new Error( "Unknown branch position type: " + posConfig.type );
            }
            let numBranches = concentration.length; //gn.math.randInt( this.system.options.style.tree_maxBranches, this.system.options.style.tree_minBranches );
            for( let i=0; i<numBranches; i++){
                let p0 = gn.geom.getPointBetweenTwoPoints( this.lineSegment.p0, this.lineSegment.p1, gn.math.random() );
                let angle;
                let angleConfig = this.system.options.style.branch_angles;
                if( angleConfig.type === 'random' ){
                    angle = gn.math.randomInRange( this.system.options.style.branch_angles.max, this.system.options.style.branch_angles.min );
                }else if( angleConfig.type === 'pick' ){
                    angle = gn.math.randomElementFromArray( this.system.options.style.branch_angles.values );
                }else if( angleConfig.type === 'by_level' ){
                    angle = angleConfig.values[this.level];
                }
                angle = gn.math.degToRad( gn.math.randomElementFromArray([angle,-angle]) );
                    
                angle += this.angle;

                let length = this.system.options.style.branch_length;
                let p1 = gn.geom.makePointAtAngleAndDistance(angle, length, p0.x, p0.y );
                let segment = new Segment( this.system, this, this.level+1, {p0:p0, p1:p1} );
                myBranches.push( segment );
            }
            let previousSegment = null;
            for( let i=0; i<myBranches.length; i++){
                let segment = myBranches[i];
                if( i > 0 && previousSegment ){
                    let prevSegmentIntersectedSegment = previousSegment.closestIntersectedSegment;
                    let segmentIntersectedSegment = segment.closestIntersectedSegment;
                    if( prevSegmentIntersectedSegment && segmentIntersectedSegment && prevSegmentIntersectedSegment == segmentIntersectedSegment ){
                        let p0 = previousSegment.lineSegment.p0;
                        let p1 = previousSegment.lineSegment.p1;
                        let p2 = segment.lineSegment.p1;
                        let p3 = segment.lineSegment.p0;
                        let polygon = new PolygonObject( this.system.style, [p0,p1,p2,p3] );
                        this.system.allPolygons.push( polygon );
                    }
                }
                previousSegment = segment;
            }

            myBranches.forEach( segment => {
                if( this.system.allSegments.length < this.system.maxSegments )
                    segment.sprout();
            });
        }
    }

    draw(appObject){
        if( this.skipDraw )
            return;
        let pp = appObject || p5App;
        let ctx = pp.drawingContext;
        pp.push();
        
        
        let strokecolor;
        let grd;
        if( this.strokeAccent ){
            strokecolor = this.system.strokeAccentColor;
        } else{
            strokecolor = this.system.options.style.palette.main;
        }
            let alpha = pick(["CC", "DD", "EE", "FF"])
        pp.stroke(strokecolor+alpha);
        let lineWidth = this.level == 0 ? this.system.options.style.seed_lineWidth : this.system.options.style.line_maxThickness / (this.level+1);
        
        
        pp.strokeWeight( Math.max( 1, lineWidth ));
        pp.strokeCap( pp.SQUARE );
        pp.line( this.lineSegment.p0.x, this.lineSegment.p0.y, this.lineSegment.p1.x, this.lineSegment.p1.y );
        pp.pop();
    }
}